export default __webpack_public_path__ + "static/metric-diagram-508066fd3a1816d2b11474e3779eb3bc.png";